// extracted by mini-css-extract-plugin
module.exports = {"button":"offer-module--button--1PTqf"};